export const SCROLL_THRESHOLD = 215
export const HITS_PER_PAGE = 36
export const MAX_VALUES_PER_FACET = 1000

export const GRID_SIZES = {
  aside: { initial: 12, md: 0, lg: 3 },
  content: { initial: 12, md: 9 }
} as const
